export const contentAmplification = {
  button: {
    label: 'Amplify to {{channel}}',
    ariaLabel: 'Amplify this content to {{channel}}',
  },
  drawer: {
    title: 'Amplify to {{channel}}',
    close: 'Close',
    reuseNote: "Reuses the blog's keyword research",
    statusDraft: 'Draft generated',
    statusGenerating: 'Generating…',
  },
  formats: {
    article: 'Article',
    posts: 'Posts',
  },
  loader: {
    title: 'Generating your {{format}} for {{channel}}…',
    subtitle: 'Analyzing the blog and reusing the keyword research',
  },
  article: {
    eyebrow: 'PREVIEW · {{channel}} ARTICLE',
    bodyLabel: 'Article body',
  },
  posts: {
    bodyLabel: 'Post body',
    author: {
      name: 'Your brand',
      tagline: 'Your company',
      meta: 'Now · 🌐',
    },
    engagement: {
      likes: 'Likes',
      comments: 'Comments',
      reposts: 'Reposts',
    },
  },
  footer: {
    copy: 'Copy',
    copied: 'Copied',
    export: 'Export',
    regenerate: 'Regenerate',
    delete: 'Delete',
    schedule: 'Schedule via IBT',
    soon: 'Soon',
  },
  deleteDialog: {
    title: 'Delete the {{format}} draft?',
    description: 'The generated content will be deleted. You can generate it again anytime.',
    cancel: 'Cancel',
    confirm: 'Delete',
  },
  empty: {
    title: 'No draft',
    description: 'There is no {{format}} generated for this content yet.',
    generate: 'Generate',
  },
  toast: {
    copied: 'Content copied to clipboard',
    copyError: 'Could not copy to clipboard',
    exported: 'Content exported',
    regenerated: 'Content regenerated',
    regenerateError: 'Could not regenerate the content',
    deleted: 'Draft deleted',
    deleteError: 'Could not delete the draft',
  },
  error: {
    title: 'Could not generate the content',
    description: 'Try again in a few seconds.',
    retry: 'Retry',
  },
} as const
